
import React from "react";
import { Offcanvas } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";

const DefaultOffCanvas = (props) => {
    const { className } = props;

    return (
        <Offcanvas
            zIndex={30002}
            {...props}
            className={cx({
                [className]: className,
                [styles.off_canvas]: true
            })}
        >
            {props.children}
        </Offcanvas>
    );
}
export default DefaultOffCanvas;
